import { TextField } from "@mui/material";
import { type FC, type ChangeEvent } from "react";

interface InputWithLabelProps {
    label: string;
    value: string | number;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    disabled?: boolean;
}

export const InputWithLabel: FC<InputWithLabelProps> = ({ label, value, onChange, type = "text", disabled = false }) => {
    return (
        <TextField
            variant="outlined"
            label={label}
            value={value}
            onChange={onChange}
            type={type}
            disabled={disabled}
            fullWidth
            InputLabelProps={{
                shrink: true,
            }}
            sx={{
                "& .MuiInputBase-root": {
                    borderRadius: "0.9rem",
                },
                "& .MuiInputLabel-root": {
                    fontSize: "0.9rem",
                    color: "rgba(0, 0, 0, 0.7)",
                },
            }}
        />
    );
};